"use strict";
/**
 * @module Services.ControlClient
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var serialiser_1 = require("./../../serialisers/serialiser");
var session_id_serialiser_1 = require("./../../session/session-id-serialiser");
var topic_selector_serialiser_1 = require("./../../topics/topic-selector-serialiser");
var client_subscribe_request_1 = require("./client-subscribe-request");
/**
 * Serialiser for {@link ClientSubscribeRequest}
 */
var ClientSubscribeRequestSerialiserClass = /** @class */ (function (_super) {
    __extends(ClientSubscribeRequestSerialiserClass, _super);
    function ClientSubscribeRequestSerialiserClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Read a {@link ClientSubscribeRequest} from the stream
     *
     * @param bis  the input stream
     * @return     the {@link ClientSubscribeRequest} that was read
     */
    ClientSubscribeRequestSerialiserClass.prototype.read = function (bis) {
        var sessionID = session_id_serialiser_1.SessionIdSerialiser.read(bis);
        var selector = topic_selector_serialiser_1.TopicSelectorSerialiser.read(bis);
        return new client_subscribe_request_1.ClientSubscribeRequest(sessionID, selector);
    };
    /**
     * Write a {@link ClientSubscribeRequest} to the stream
     *
     * @param bos    the output stream
     * @param value  the {@link ClientSubscribeRequest} to be written
     */
    ClientSubscribeRequestSerialiserClass.prototype.write = function (bos, value) {
        session_id_serialiser_1.SessionIdSerialiser.write(bos, value.sessionID);
        topic_selector_serialiser_1.TopicSelectorSerialiser.write(bos, value.selector);
    };
    return ClientSubscribeRequestSerialiserClass;
}(serialiser_1.AbstractSerialiser));
exports.ClientSubscribeRequestSerialiserClass = ClientSubscribeRequestSerialiserClass;
/**
 * The {@link ClientSubscribeRequestSerialiser} singleton
 */ // tslint:disable-next-line:variable-name
exports.ClientSubscribeRequestSerialiser = new ClientSubscribeRequestSerialiserClass();



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/control-client/client-subscribe-request-serialiser.js
// module id = 1318
// module chunks = 0